export default __webpack_public_path__ + "static/media/ripple.dbcc9096.png";